import { render, staticRenderFns } from "./PxCamposCompraNeo.vue?vue&type=template&id=0c08738c&"
import script from "./PxCamposCompraNeo.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraNeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports